import { render, staticRenderFns } from "./UpdateActions.vue?vue&type=template&id=1e125878&scoped=true&"
import script from "./UpdateActions.vue?vue&type=script&lang=js&"
export * from "./UpdateActions.vue?vue&type=script&lang=js&"
import style0 from "./UpdateActions.vue?vue&type=style&index=0&id=1e125878&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e125878",
  null
  
)

export default component.exports